import React, { useState, useContext, useEffect } from "react"
import ReactModal from "react-modal"

import Wrapper from "../layout/wrapper/wrapper"

import Cross from "../../../assets/svg/cross.svg"

import styles from "./modal.module.scss"

ReactModal.setAppElement("#___gatsby")

/*
  Example usage:
   import * as Modal from "../modal/modal"

    <Modal.Wizard>
        <Modal.Trigger>
            <span>I am triggering modal</span>
        </Modal.Trigger>
        <Modal.Content>
            <p>Hello world!</p>
        </Modal.Content>
    </Modal.Wizard>

*/

const WizardContext = React.createContext({
  toggleModal: () => {},
  isOpen: false,
})

export const Wizard = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (isOpen) {
      document.documentElement.classList.add("no-scroll")
    } else {
      document.documentElement.classList.remove("no-scroll")
    }
  }, [isOpen])

  function toggleModal() {
    setIsOpen(!isOpen)
  }

  return <WizardContext.Provider value={{ toggleModal, isOpen }}>{children}</WizardContext.Provider>
}

export const Trigger = ({ children }) => {
  const { toggleModal } = useContext(WizardContext)
  return (
    <button className={styles.trigger} onClick={toggleModal}>
      {children}
    </button>
  )
}

export const Content = ({ children }) => {
  const { toggleModal, isOpen } = useContext(WizardContext)

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={toggleModal}
      className={styles.modal}
      overlayClassName={styles.overlay}
      closeTimeoutMS={300}
    >
      <Wrapper>
        <button className={styles.close} onClick={toggleModal}>
          <Cross />
        </button>
        <div>{children}</div>
      </Wrapper>
    </ReactModal>
  )
}
